var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12"},[_c('indexHeader',{attrs:{"title":_vm.$t('Customers'),"description":_vm.$t('From here you can edit your customers details'),"showExport":'true',"exportLink":_vm.path + '/export/excel',"showImport":'true',"explanationPath":_vm.path + '/explaination'}}),_c('indexTable',{attrs:{"searchText":_vm.$t('Search for a customer'),"emptyTableText":_vm.$t('There are no customers'),"emptyTableSubText":_vm.$t('Try adding some items to the table and try again'),"buttonRole":_vm.$checkRole('customers_add'),"localData":true,"cloumns":[
          { column: 'id', title: _vm.$t('Code'), type: 'mainLink', sort: true },
          {
            column: 'name',
            title: _vm.$t('Customer name'),
            type: 'mainLink',
            sort: true
          },
          {
            column: 'tax_number',
            title: _vm.$t('Customer code'),
            type: 'text',
            sort: true
          },
          {
            column: 'mobile',
            title: _vm.$t('Phone number'),
            type: 'text',
            sort: true,
            icon: 'phone'
          },
          {
            column: 'balance',
            title: _vm.$t('Balance'),
            type: 'text',
            sort: true,
            icon: 'usd-square'
          },
          {
            column: 'stat',
            title: _vm.$t('Active'),
            type: 'stat',
            sort: true,
            hideMobile: true
          },
          {
            column: 'options',
            title: _vm.$t('Actions'),
            type: 'options',
            options: [
              { name: 'show' },
              {
                name: 'edit',
                role: _vm.$checkRole('customers_edit')
              },
              {
                name: 'link',
                role: _vm.$checkRole('sales_payments_add'),
                title: _vm.$t('Add payment'),
                icon: 'dollar-sign',
                link: '/salesPayments/create?customer_id='
              },
              {
                name: 'link',
                role: _vm.$checkRole('quotations_add'),
                title: _vm.$t('Add quotation'),
                icon: 'calculator',
                link: '/quotations/create?customer_id='
              },
              {
                name: 'link',
                role: _vm.$checkRole('invoices_add'),
                title: _vm.$t('Add sales bill'),
                icon: 'file-invoice-dollar',
                link: '/invoices/create?customer_id='
              },
              {
                name: 'link',
                role: _vm.$checkRole('orders_add'),
                title: _vm.$t('Add order'),
                icon: 'briefcase',
                link: '/orders/create?customer_id='
              },
              {
                name: 'delete',
                role: _vm.$checkRole('customers_delete')
              }
            ]
          }
        ],"deleteText":{
          attention: _vm.$t('Attention'),
          areYouReallySureToDeleteTheItem: _vm.$t(
            'Are you really sure the Client is deleted, If you delete the customer all invoices and processes will be deleted'
          ),
          close: _vm.$t('Close'),
          confirm: _vm.$t('Confirm'),
          loading: _vm.$t('Loading')
        }}})],1)]),(_vm.importShow)?_c('importForm'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }